import { attr, belongsTo } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class CompanyPostingStat extends ShModel {
  @attr('number') applicationsAwaitingReview;
  @attr('number') draftPostings;
  @attr('number') hiresMade;
  @attr('number') hiresMadeYtd;
  @attr('number') inReviewPostings;
  @attr('number') livePostings;
  @attr('date') nextPostingExpiration;

  @belongsTo('company', { async: false }) company;
}

export default CompanyPostingStat;
